import {Extension} from "@tiptap/core";
import type {Node as ProseMirrorNode} from "@tiptap/pm/model";
import {Plugin, PluginKey} from "@tiptap/pm/state";
import {PRINTOUT_FOOTER_NODE_NAME} from "../blocks/headerFooter/printoutRegionOptions";

const isEmptyParagraph = (node?: ProseMirrorNode | null) => (
    node?.type.name === 'paragraph' && node.content.size === 0
);

const getBodyEnd = (document: ProseMirrorNode) => {
    const footer = document.lastChild?.type.name === PRINTOUT_FOOTER_NODE_NAME
        ? document.lastChild
        : null;

    return {
        insertPosition: footer ? document.content.size - footer.nodeSize : document.content.size,
        lastBodyNode: footer
            ? (document.childCount > 1 ? document.child(document.childCount - 2) : null)
            : document.lastChild,
    };
};

// Keep a text insertion point after the final body block, immediately before the fixed footer.
export const PrintoutTrailingBodyParagraph = Extension.create({
    name: 'printoutTrailingBodyParagraph',

    addProseMirrorPlugins() {
        const pluginKey = new PluginKey(this.name);

        return [
            new Plugin({
                key: pluginKey,
                appendTransaction: (transactions, _previousState, state) => {
                    if (!transactions.some(transaction => transaction.docChanged)) return;

                    const paragraphType = state.schema.nodes.paragraph;
                    if (!paragraphType) return;

                    const {insertPosition, lastBodyNode} = getBodyEnd(state.doc);
                    if (isEmptyParagraph(lastBodyNode)) return;

                    return state.tr.insert(insertPosition, paragraphType.create());
                },
            }),
        ];
    },
});

export default PrintoutTrailingBodyParagraph;
